import { Grid, Typography as Type } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";

const ProductPurityDetails = () => {
  const location = useLocation();
  const { prodPurityId } = location?.state || {};
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    if (prodPurityId && prodPurityId?.product_metal_name) {
      setBreadcrumbs([
        { key: "1", href: "/userList", text: "Master" },
        { key: "2", href: "/productPurity", text: "Product Purity" },
        {
          key: "3",
          href: `/productPurity`,
          text: `View Details`,
        },
      ]);
    }
  }, [prodPurityId]);

  const DetailItem = ({ label, value }) => (
    <Grid
      item
      xs={12}
      sm={18}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "8px 0",
        width: "30vw",
      }}
    >
      <Type variant="subtitle1" style={labelInfoStyle}>
        <div style={labelTxtStyle}>{label}</div>
      </Type>
      <Type
        style={{
          width: "100%",
          justifyContent: "start",
          display: "flex",
        }}
      >
        <div style={inputTextStyle}>
          :
          <p
            style={{
              fontSize: 16,
              fontWeight: "400",
              fontFamily: Fonts.Poppins,
              color: Colors.darkGray,
              marginLeft: "5px",
            }}
          >
            {value}
          </p>
        </div>
      </Type>
    </Grid>
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 85%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          display: "grid",
          gridTemplateRows: "15% 80%",
          backgroundColor: Colors.bgColor,
        }}
      >
        <div style={{ width: "94%" }}>
          <TopNavBar leftSideText={"Metal Purity"} />
          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer
          component={Paper}
          style={{
            width: "90%",
            borderRadius: "6px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            marginTop: "10px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginLeft: "25px",
          }}
        >
          <h1 style={mainHeadingStyle}>Metal Purity Information</h1>

          <hr style={{backgroundColor: Colors.borderColor}} />

          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid
              item
              xs={12}
              sm={4}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 0",
                width: "70vw",
                marginLeft: "70px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <DetailItem
                  label="Product Metal Purity ID"
                  value={prodPurityId?.product_metal_purity_id || "-"}
                />
                <DetailItem
                  label="Product Metal Purity Value"
                  value={prodPurityId?.product_metal_purity_value || "-"}
                />
              </div>
            </Grid>
          </Grid>
        </TableContainer>
      </div>
    </div>
  );
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  display: "flex",
  alignItems: "center",
  width: "80%",
};

const labelTxtStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  display: "flex",
  alignItems: "center",
  width: "100%",
};

export default ProductPurityDetails;
